import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { getPresignedUrl } from "../queryFunctions/getPresignedUrl";
import type { GetPresignedUrlForGetPayload, GetPresignedUrlForGetResponse } from "@/core/types";
import { usePresignedUrlKey } from "../keyFactory";

export function useGetPresignedUrl({
  options,
  payload,
}: {
  options?: Omit<UseQueryOptions<GetPresignedUrlForGetResponse>, "queryKey" | "queryFn">;
  payload: Omit<GetPresignedUrlForGetPayload, "method" | "content_type">;
}) {
  return useQuery({
    queryKey: usePresignedUrlKey.get(payload),
    queryFn: () => getPresignedUrl(payload),
    ...options,
  });
}
